var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgDocumentRequest = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 25.714, height: 36 }, props, { children: [_jsx("path", { "data-name": "Path 228", d: "m25.328 9.387-9-9a1.167 1.167 0 0 0-.9-.386H2.571A2.579 2.579 0 0 0 0 2.572v30.857a2.579 2.579 0 0 0 2.571 2.572h20.572a2.579 2.579 0 0 0 2.571-2.571V10.287a1.167 1.167 0 0 0-.386-.9Zm-9.9-6.3 7.2 7.2h-7.2Zm7.714 30.342H2.571V2.572h10.286v7.714a2.579 2.579 0 0 0 2.571 2.571h7.714Z" }), _jsx("path", { "data-name": "Path 238", d: "m7.2 22.801 1.265 1.265 3.84-3.84v8.575h1.79v-8.576l3.84 3.84 1.265-1.264-6-6Z" })] }))); };
export default SvgDocumentRequest;
